import React from 'react';
import '../styles/Login.css'; // Create this CSS file for any specific styles for auth layout

const AuthLayout = ({ children }) => {
  return (
    <div className="auth-wrapper">
      <div className="auth-inner">
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;